import {manifest} from '@/constant/env.js';
import {Browser} from '@capacitor/browser';
import userService from '@/services/user';
import {getLocale} from '@/i18n/utils.js';
import localeConfigs from '@/config/locale.js';

const isLocalhost = window.location.hostname === 'localhost';
const LOCALHOST_HOME_PAGE_PORT = 3000;
/**
 * Open the home page.
 * @param {string} path - The path to navigate to.
 * @param {boolean} isNoLogin - Flag indicating if the user is not logged in.
 */
const openHomePage = async ({path = '/', isNoLogin = false, username} = {}) => {
  let baseUrl = manifest.homePageUrl;
  if (isLocalhost) baseUrl = `http://localhost:${LOCALHOST_HOME_PAGE_PORT}`;
  if (path.indexOf('/') !== 0) path = `/${path}`;
  const pathLocale = path.split('/')[1];
  if (!localeConfigs.some((l) => l.code === pathLocale)) {
    path = `/${getLocale()}${path}`;
  }
  const url = new URL(path, baseUrl);
  if (!isNoLogin && username) {
    const otp = await userService.createOtp();
    url.searchParams.set('otp', otp);
    url.searchParams.set('username', username);
  }
  await Browser.open({
    url: url.href,
    presentationStyle: 'popover',
  });
};

export default openHomePage;
